import { Observable } from 'rxjs'
import { Position } from '../../models/position.model'

export abstract class PositionsService {
  abstract getPositions(executionId: number): Observable<Position[]>
}
